import Sangria from "@/Pages/Caixas/sangria.vue";
import temPermissao from "./guards/temPermissao";

export default [
  {
    path: "/sangria",
    name: "sangria",
    component: Sangria,
    beforeEnter: (to, from, next) => {
      if (!temPermissao("caixas.abrir", to, from, next)) return;
      next();
    },
  },
];
